import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// CRITICAL: Ionic CSS must be imported before your global CSS
import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';
import '@ionic/react/css/display.css';
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/flex-utils.css';

// Your custom global CSS (must be AFTER Ionic CSS)
import './global.css';

// ============================================================
// SET API URL for social auth service (avoids import.meta.env TS issues)
// ============================================================
(window as any).__NURWALLET_API_URL__ = 'http://localhost:3000';

// Initialize auth store from localStorage before render
const initAuth = () => {
  try {
    const stored = localStorage.getItem('nurwallet-auth-storage');
    if (stored) {
      const parsed = JSON.parse(stored);
      // Auth store saves { user, isAuthenticated, isGuest } (no .state wrapper).
      // Keep parsed.state fallback for backward compatibility with old persist shape.
      const userId = parsed.user?.id || parsed.state?.user?.id;
      if (userId) {
        (window as any).__NURWALLET_USER_ID__ = userId;
      }
    }
  } catch (e) {
    console.log('No stored auth found');
  }
};

initAuth();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);